export const TypeofPlant = [
    {id: 0, name: "Manual"},
    {id: 1, name: "Semi-Automatic"},
    {id: 2, name: "Fully Automatic"},
]